import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation,Navigate  } from 'react-router-dom';
import { UserProvider } from './components/UserProvider.tsx'; // Import UserProvider
import Sidebar from './components/Navbar.tsx';
import StudentDashboard from './components/StudenttDashboard.tsx';
import UserManagement from './components/UserManagement.tsx';
import SponsorshipAnnouncement from './components/SponsorshipAnnouncement.tsx';
import StudentPortal from './components/StudentPortal.tsx';
import StudentProfile from './components/Profile.tsx';
import LoginPage from './components/Login.tsx';
import GoAttend from './components/GoAttend.tsx';

const AppContent: React.FC = () => {
  const location = useLocation(); // Correctly use `useLocation` inside Router

  return (
    <div
      className="flex min-h-screen bg-cover bg-center relative"
      style={{ backgroundImage: 'url(https://tronova.azmiproductions.com/img/backy.png)' }}
    >
      {/* Conditionally render Sidebar */}
      {location.pathname !== '/login' && <Sidebar />}

      {/* Main Content Area */}
      <div
        className={`flex-1 ${
          location.pathname === '/login' ? '' : 'bg-black bg-opacity-60'
        } overflow-y-auto`}
      >
        <Routes>
          <Route path="/" element={<StudentDashboard />} />
          <Route path="/user" element={<UserManagement />} />
          <Route path="/sponsor" element={<SponsorshipAnnouncement />} />
          <Route path="/portal" element={<StudentPortal />} />
          <Route path="/profile" element={<StudentProfile />} />
          <Route path="/go" element={<GoAttend />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </div>
  );
};

const AppWrapper: React.FC = () => (
  <Router>
    <UserProvider>
      <AppContent />
    </UserProvider>
  </Router>
);

export default AppWrapper;
